<script setup lang="ts">
import { useTerminologyData } from '@/composables/useTerminologyData';
import { computed } from 'vue';
import { getI18n } from '@/helpers/i18n';


const props = withDefaults(defineProps<{ path: string[]; headerSize?: number; title?: string; size?: string }>(), {
    path: () => [],
    headerSize: 4,
    title: () => getI18n().t('important_terms'),
    size: 'large'
});
const terminology = useTerminologyData(props.path);

const headerTag = computed(() => {
    return 'h' + props.headerSize;
});
const headerClass = computed(() => {
    return 'ktg-title-0' + props.headerSize;
});
</script>
<template>
    <ktg-loader v-if="terminology.loading.value"></ktg-loader>
    <div v-else>
        <component :is="headerTag" :class="headerClass">{{ props.title }}</component>
        <ktg-accordion class="mt-3rem accordion">
            <ktg-accordion-item
                v-for="data in terminology.data.value"
                :key="data.title"
                :size="props.size"
                :content-title="data.title"
            >
                <span class="ktg-body-small" v-html="data.content"></span>
            </ktg-accordion-item>
        </ktg-accordion>
    </div>
</template>

<style scoped>
.accordion {
    margin-left: -1rem;
}
:deep(p) {
    margin-bottom: 0.5em;
}
:deep(ul),
:deep(ol) {
    margin-left: 1em;
}
</style>
